package meineglasfaser.api.ubl

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class UBLPostalAddress(
    @SerialName("street_name")
    val streetName: String,
    @SerialName("city_name")
    val cityName: String,
    @SerialName("postal_code")
    val postalCode: String,
    @SerialName("country_code")
    val countryCode: String,
) {
    companion object {
        val EMPTY_AUSTRIA = UBLPostalAddress(
            streetName = "",
            cityName = "",
            postalCode = "",
            countryCode = "AT",
        )
    }
}
